import { Injectable, inject } from '@angular/core'

import { Observable } from 'rxjs'

import { AuthConfigService } from './auth.service'

@Injectable()
export class AuthGuard {
  private authService = inject(AuthConfigService)

  canActivate(): Observable<boolean> {
    return this.authService.isAuthenticated$
  }
}
